import React, { forwardRef } from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlay } from "@fortawesome/free-solid-svg-icons";

const sizes = {
  lg: "w-2/5",
  normal: "w-1/5",
};

const VideoPreview = forwardRef(
  ({
    size = "normal",
    className = "",
    image,
    link,
    title,
    tags = [],
    ...props
  }) => {
    return (
      <a
        href={link}
        target="_blank"
        rel="noreferrer"
        className={classNames(
          "video-preview",
          className,
          sizes[size],
          "rounded-lg relative overflow-hidden",
          { lg: size === "lg" }
        )}
        {...props}
      >
        <div
          className="video-preview__image absolute center-absolute"
          style={{
            backgroundImage: `url(${image})`,
          }}
        />

        <FontAwesomeIcon
          className="text-white absolute center-absolute mb-32 z-10"
          icon={faPlay}
          size="3x"
        />

        <div className="video-preview__title absolute z-20">
          <div className="video-preview__title-text">{title}</div>
          <div className="video-preview__tags">
            {tags.map(tag => (
              <span className="video-preview__tags-item">{tag}</span>
            ))}
          </div>
        </div>
      </a>
    );
  }
);

VideoPreview.propTypes = {
  size: PropTypes.string.isRequired,
  // eslint-disable-next-line react/require-default-props
  className: PropTypes.string,
  image: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  tags: PropTypes.arrayOf(PropTypes.node),
};

export default VideoPreview;
